export default "__VITE_ASSET__Czu0aTYI__"